import React from "react";
import NumberInput from "../../input/number-input";

const Number1Widget = ({ widget, onValueUpdate }) => {
  const handleValueUpdate = (data) => {
    const updatedWidget = { ...widget, value: data.toString() };
    onValueUpdate(updatedWidget);
  };

  return (
    <div className="flex items-center h-full w-full">
      {widget && (
        <NumberInput
          valueSpec={widget}
          onChange={handleValueUpdate}
          onError={() => {}}
        />
      )}
    </div>
  );
};

export default Number1Widget;
